(function () {
  var ACTIVE = 'stl__hotspot--active';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.stl__hotspot-btn');
    if (btn) {
      e.preventDefault();
      var hotspot = btn.closest('.stl__hotspot');
      var isOpen = hotspot.classList.contains(ACTIVE);

      // Close every open hotspot first
      document.querySelectorAll('.' + ACTIVE).forEach(function (el) {
        el.classList.remove(ACTIVE);
      });

      // Toggle the clicked one
      if (!isOpen) {
        hotspot.classList.add(ACTIVE);
      }
      return;
    }

    // Click outside any hotspot closes all
    if (!e.target.closest('.stl__hotspot')) {
      document.querySelectorAll('.' + ACTIVE).forEach(function (el) {
        el.classList.remove(ACTIVE);
      });
    }
  });
})();
